import { useUserStore } from '@/store';
import { MemberState, VirtualTargetType } from '@/types';
import { commonUtils } from '../common';
import { toast } from '../toast';

export default {
  /**
   * 会员卡商品支付前校验
   * @returns
   */
  paymentMemberVerify: async (orderDetails: AnyObject) => {
    const userStore = useUserStore();
    if (
      [VirtualTargetType.MemberCard].includes(
        orderDetails.lines[0].productVariant.customFields.virtualTargetType
      )
    ) {
      const memberInfo = await userStore.getUserMemberInfo(true);
      if (memberInfo) {
        if (memberInfo.state === MemberState.unactivated) {
          toast.message(`已有待激活会员卡无需再购买`);
          return false;
        }
        if (memberInfo.state === MemberState.normal) {
          toast.message(`已有会员卡无需再购买`);
          return false;
        }
      } else {
        console.log(`paymentVerify - 用户会员信息不存在`, userStore);
      }
    }
    return true;
  },
  /**
   * 校验中国手机号码
   * @param phone
   * @returns
   */
  isValidChinaPhoneNumber: (phone: string): boolean => {
    const regex = /^(1[3-9]\d{9}|[569]\d{7}|9\d{8})$/;
    return regex.test(phone);
  },
  /**
   * 号码隐私处理
   * @param phone
   * @returns
   */
  maskPhoneNumber(phone: string): string {
    const len = phone?.length ?? '';

    if (!phone) return '';

    if (len < 3) return phone; // 长度小于 3，直接返回原始号码

    // 根据号码长度生成处理后的号码
    switch (len) {
      case 3:
        return `${phone[0]}${phone[1]}*`;
      case 4:
        return `${phone[0]}**${phone[3]}`;
      case 5:
        return `${phone[0]}***${phone[4]}`;
      case 6:
        return `${phone[0]}****${phone[5]}`;
      case 7:
        return `${phone.slice(0, 2)}****${phone[6]}`;
      case 8:
        return `${phone.slice(0, 3)}****${phone[7]}`;
      case 9:
        return `${phone.slice(0, 3)}****${phone.slice(7)}`;
      case 10:
        return `${phone.slice(0, 3)}****${phone.slice(7)}`;
      case 11:
        return `${phone.slice(0, 3)}****${phone.slice(7)}`;
      default:
        // 对超过 11 位的号码，按类似规则处理
        return `${phone.slice(0, 3)}****${phone.slice(-4)}`;
    }
  },
  infos() {
    const userStore = useUserStore();
    const uu = userStore.userInfo;

    // 昵称
    const name = uu?.lastName || `登录/注册`;

    // 头像
    const avatar = uu?.customFields?.headPortrait || commonUtils.img.remote('default_avatar');

    // 手机号
    const phoneNumber = this.maskPhoneNumber(uu?.phoneNumber);

    // 积分
    const points = uu?.availablePoints ?? 0;

    // 是否授权过头像昵称
    const isModified = uu?.customFields?.isModified;

    return {
      name,
      avatar,
      phoneNumber,
      points,
      isModified,
    };
  },
};
